/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    REFRESH: 'Rafraîchir',
    ENERGYPERFORMANCE: "Économies d'énergie",
    UTILITYBILLSAVINGS: 'Frais de facture de services ',
    DateFrom: 'Date de début',
    SITES: 'Sites',
    ENERGYMANAGEMENTDASHBOARDTITLE: "Score de la gestion de l'énergie",
    BASELINE: 'Niveau de référence',
    BASELINEKEY: 'Consommation de référence',
    ACTUALKEY: 'Consommation réelle',
    SAVINGS: 'Économies',
    ACTUAL: 'Réel',
    PARTIAL_MONTH: 'Mois partiel',
    ACTUALEMISSIONS: 'Émissions réelles',
    ACTUALEMIS: 'Émis. réelles',
    PREVIOUSEMIS: 'Émis. précédentes',
    PREVIOUSEMISSIONS: 'Émissions précédentes',
    TOTALCONSUMPTION: 'Consommation totale',
    EMISSION: 'Émissions',
    ACTUALAVOIDANCE: 'Évitement réel',
    PREVIOUSPERIOD: 'Période préc.',
    PREVIOUS: 'Précédent',
    PREVIOUSAVOIDANCE: 'Évitement précédent',
    ACTUALCOST: 'Coût réel',
    actualCost: 'CONSO RÉELLE',
    BASELINECOST: 'Coût de référence',
    baselineCost: 'CONSO DE RÉF.',
    PREVSPER: 'PÉRIODE PRÉCÉDENTE',
    PREVIOUSCOST: 'Coût précédent',
    VIEWDETAILS: 'AFFICHER LES DÉTAILS',
    ADVANCED: 'Avancé',
    BASIC: 'De base',
    MONTHLY: 'Mensuel',
    BILLING: 'Facturation',
    LIVEMETER: 'Compteurs en direct',
    UTILITYMETER: 'Compteurs de services',
    LIVEREADING: 'Compteurs sur site',
    UTILITYINTERVAL: 'Intervalle des services',
    UTILITYPROVIDERNEW: 'Services mensuels',
    ACTUALCONSUMPTION: 'Consommation réelle',
    BASELINECONSUMPTION: 'Consommation de référence',
    PREDICTED: 'Prévu',
    Utilitycost: 'Coût utilitaire pour',
    UtilityBill: 'Présentation des factures utilitaires',
    UtilityCost: 'Coût utilitaire',
    ActualCost: 'Coût réel',
    CostPercentage: 'Coût (%)',
    Electricity: 'Électricité',
    Gas: 'Gaz',
    Water: 'Eau',
    UtilityType: "Type d'utilitaire",
    all: 'tout',
    electricity: 'électricité',
    gas: 'gaz',
    water: 'eau',
    BASICSITEWITHDATACOUNTMESSAGE:
      "* Les factures de services pour la consommation d'énergie ont été générées pour {siteWithDataCount} des {totalSiteCount} sites.",
    CARBONUTILITYGRAPHTOOLTIP:
      '* Les émissions correspondant aux factures de services ont été générées pour {siteWithDataCount} des {totalSiteCount} sites.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Des émissions de lectures en direct ont été générées pour {siteWithDataCount} des {totalSiteCount} sites.',
    ENERGYUTILITYGRAPHTOOLTIP:
      "* Les consommations d'énergie liées aux factures de services ont été générées pour {siteWithDataCount} des {totalSiteCount} sites.",
    ENERGYLIVEGRAPHTOOLTIP:
      '* Des lectures en temps direct ont été générées pour {siteWithDataCount} sur {totalSiteCount} sites.',
    UtilityTypeforselectutility: "Type d'utilitaire*",
    ENABLEIDSCHECKBOX: "Activer le service de données d'intervalle (IDS)",
    ENABLED: 'Activé',
    DISABLED: 'Désactivé',
    CONVERSIONINFOMSG:
      "Veuillez fournir vos informations d'identification pour permettre la conversion de ce numéro de compte d'un type d'intégration « manuel » à un type d'intégration « automatique ». Une fois \n    les informations d'identification vérifiées, le type d'intégration sera mis à jour automatiquement. Les données enregistrées manuellement seront conservées et les prochaines factures \n    seront mises à jour automatiquement par la suite.",
    CO2: 'CO2',
    CARBON: 'Carbone({unit})',
    CARBONNOUNIT: 'Carbone',
    CARBONEMISSION: 'Émissions de carbone',
    METERDATA1: 'Données du compteur',
    DATANEEDED: 'Données nécessaires',
    METERDATA: 'Données du compteur',
    METERDATASUBTITLE:
      'Analysez et comparez la consommation de compteur en chargeant des données historiques et/ou manquantes sur la période.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'CONSOMMATION ÉLECTRIQUE',
    ELECTRICITYPERFORMANCE: 'Performance électrique',
    Electicity:
      " Les données d'électricité, de gaz et d'eau peuvent être intégrées en combinant vos comptes",
    FORECAST: 'Prévision',
    ALL: 'Tout',
    ELECTRICITY: 'Électricité',
    GAS: 'Gaz',
    WATER: 'Eau',
    METER: 'COMPTEUR',
    SavingMeter: 'Économies par compteur',
    BREAKDOWNMETER: 'Conso par compteur',
    BREAKDOWNBYAREAS: 'Répartition par secteur',
    BREAKDOWNBYEQUIPMENTTYPE: "Répartition par type d'équipement",
    CONSUMPTIONBYUTILITIES: 'Conso par utilitaire',
    ENERGYBREAKDOWNOFUTILITY: "Répartition de l'utilitaire",
    ENERGYBREAKDOWNBYMETERS: 'Répartition par compteurs',
    WATERBREAKDOWNBYLIVEMETERS: 'Répartition par compteurs en direct',
    BREAKDOWNOFUTILITY: 'Répartition des charges utilitaires',
    breakdownUtility: 'Répartition par utilitaire',
    breakdownCarbon: 'Répartition des compteurs',
    breakdownCarbonScopeOne: 'Répartition par catégorie',
    breakdownFuel: 'Répartition des types de carburant',
    breakdownAreas: 'Répartition par secteur',
    areasHeader: ' Secteurs',
    metersHeader: 'Compteurs',
    areasSubHeaders:
      "La répartition suivante de la consommation d'électricité est effectuée en fonction des secteurs et pour une durée sélectionnée.",
    baselinebutton: 'Créer une référence',
    LAST_BASELINE_TRAINED_DATE: 'Dernière référence entraînée le',
    apply: 'Appliquer',
    back: 'Précédent',
    baselinetraning: 'Entraînement de référence',
    chooseTrainingDateRange: "Choisir une plage de dates pour l'entraînement",
    applyBaselineFrom: 'Appliquer la référence de',
    historicDataTooltip:
      'Concernant les données historiques chargées, la référence sera visible pour les 15 derniers jours dans le tableau de bord et les rapports.',
    excludeSpecificDateRangeQ:
      'Préférez-vous exclure une plage de dates spécifique ?',
    excludeDateRange: 'Exclure la plage de dates',
    howitworks: 'Comment cela fonctionne-t-il ?',
    howitworksone:
      'Toutes les données de compteur chargées seront utilisées pour former un modèle de référence de bonne qualité',
    howitworkstwo:
      'Les données de référence sont affichées sur le tableau de bord et dans les rapports pour les 15 derniers jours à partir de la date du chargement',
    howitworksthree:
      'Pour obtenir les meilleurs résultats de référence, il est recommandé de disposer de 12 mois de données',
    howitworksfour:
      '30 jours minimum de données sont nécessaires pour la formation des modèles',
    howitworksfive:
      "L'entraînement de référence est appliqué aux données de tous les compteurs du site",
    howitworkssix:
      "Lorsque vous entraînez à nouveau le modèle de référence, le modèle existant est remplacé en fonction de la nouvelle période d'entraînement de référence",
    baselinedaterangeheader: "Choisir une période d'entraînement de référence",
    baselinedaterangesubheader:
      'Sélectionnez la plage de dates pour le modèle de référence, que vous souhaitiez inclure ou exclure une période spécifique.',
    redirectmsg1: 'Vous serez redirigé dans',
    redirectmsg2: 's.',
    uploadingmsg:
      "Veuillez patienter pendant que nous initions le processus d'entraînement de référence. Vous servez averti par e-mail une fois l'entraînement terminé.",
    meterSubHeaders:
      'Le tableau fournit une répartition des compteurs sur le site ainsi que plusieurs indicateurs clés de performance.',
    breakdownCarbonSites: 'Émissions de carbone par sites ({count})',
    ENERGYUSAGE: 'Consommation énergétique',
    ENERGYUSAGECONSUMPTION: 'Consommation',
    USAGEConsumption: 'Consommation',
    WATERUSAGE: "Utilisation de l'eau",
    NILMTOOLTIPHEADER: 'Surveillance de la charge non-intrusive (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Désagrégation énergétique',
    ENERGYUSAGEOVERVIEW: 'Aperçu de la consommation énergétique',
    CONSUMPTIONOVERVIEW: 'Aperçu de la consommation',
    LOADING: 'Chargement',
    SUBMITTING: 'Soumission',
    NODATAAVAILABLE: 'Aucune donnée pour la période de date sélectionnée',
    UTILITYYEAROUTOFRANGE:
      "Veuillez sélectionner une plage de dates dans l'année",
    NOTSUBSCRIBED: 'Non abonné',
    CONNECTIONERROR:
      "Nous n'avons pas pu nous connecter au\nservice. Réessayez",
    CONNECTIONERRORTITLE: 'Erreur de connexion !',
    WATERTOOLTIPHEADER: "Consommation d'eau",
    CARBONSAVINGSMETERHEADER: 'Émissions par catégorie',
    CARBONKPIDETAILS: 'Émissions de carbone pour',
    ENERGYUSAGEDETAILS: 'Consommation énergétique pour',
    WATERUSAGEDETAILS: "Utilisation de l'eau pour",
    CarbonSavingMeter: 'Économies par utilitaire',
    SITENAMESHEADER: 'Répartition par site',
    CARBONTOOLTIPHEADER: 'Émissions de carbone',
    GASTOOLTIPHEADER: "Économies d'énergie sur le gaz",
    ALLTOOLTIPHEADER: "Économies d'énergie",
    METEROVERVIEW: 'Aperçu du compteur',
    METERANALYSIS: 'Analyse du compteur',
    ID: 'ID',
    TYPE: 'Type',
    DEVIATION: 'Déviation',
    HIGH: 'Élevée({unit})',
    HIGHWITHOUTUNIT: 'Élevée',
    LOW: 'Faible({unit})',
    LOWWITHNOUNIT: 'Faible',
    ENERGY: 'Énergie({unit})',
    ENERGYNOUNIT: 'Énergie',
    CHANGE: 'Modifier',
    CARBONTAB: 'Carbone (CO2e)',
    ENERGYTAB: 'Énergie',
    WATERTAB: 'Eau',
    EUITAB: 'EUI',
    UTILITYCOST: 'Utilitaire',
    actualConsumption: 'CONSOMMATION RÉELLE',
    actualCons: 'CONSO RÉELLE',
    baselineConsumption: 'CONSOMMATION DE RÉFÉRENCE',
    baselineCons: 'CONSO DE RÉF.',
    ConsumptionSavingsPercentage: '% CONSO ÉCONOMIES',
    ConsumptionChange: 'CONSO MODIFIER',
    ConsSavings: 'CONSO ÉCONOMIES',
    utiltactualCost: 'COÛT RÉEL',
    utilpreviousCost: 'COÛT PRÉCÉDENT',
    SavingsPercentage: '% ÉCONOMIES',
    utilchange: 'MODIFIER',
    NODATA: 'Aucune donnée',
    ENERGYKPIDETAILS: 'Performance électrique pour',
    ENERGYPERFORMANCEALL: 'Performance énergétique',
    NILMENERGYUSAGE: 'Consommation énergétique',
    NILMENERGYUSAGESUBHEADER:
      "Le graphique indique la consommation d'énergie au cours de la période sélectionnée.",
    ALLKPICARDDETAILS: 'Performance énergétique pour',
    WATERCONSUMPTIOND: "Consommation d'eau pour",
    ENERGYCONSUMPTIONMETER: 'Consommation par compteur',
    WATERCONSUMPTION: "Consommation d'eau",
    ALLUTILITIES: 'Tous les utilitaires',
    ALLEnergySources: "Toutes les sources d'énergie",
    WaterPerformance: "Performance de l'eau",
    WaterOverview: "Aperçu de l'eau",
    GASPERFORMANCE: 'Performance du gaz pour',
    GASPERFORMANCEDETAILS: 'Performance du gaz',
    WATERPERFORMANCEDETAILS: "Performances de l'eau",
    SEWERAGEPERFORMANCE: "Performance du réseau d'assainissement",
    ALLSAVINGSBYUTILITY: 'Économies BTU par utilitaire',
    TOTALENERGYCOST: "Coût total de l'énergie",
    TOTALSAVINGS: 'Total des économies',
    TOTALFOOTSPRINT: 'Empreinte totale',
    INTEGRATIONTYPE: "TYPE D'INTÉGRATION",
    UTILITYPROVIDER: "FOURNISSEUR D'UTILITAIRES",
    ACCOUNTNUMBER: 'NUMÉRO DE COMPTE',
    STATUS: 'ÉTAT',
    UDSSTATUS: 'Monthly DS Status',
    IDSSTATUS: 'Interval DS Status',
    ACTIONS: 'Actions',
    SERVICESOVERVIEW: 'Aperçu des services',
    AddService: 'AJOUTER UN SERVICE',
    AllServices: 'Tous les services',
    Active: 'Actif',
    Inactive: 'Inactif',
    Sewerage: "Réseau d'assainissement",
    ServiceProvider: 'Fournisseur de services',
    AccountNumber: 'Numéro de compte',
    CANCEL: 'ANNULER',
    SELECTALL: 'Tout sélectionner',
    SEARCH: 'Rechercher',
    SHOWACCOUNTNUMBERS: 'Afficher tous les numéros de compte',
    BACK: 'RETOUR',
    SUBMIT: 'SOUMETTRE',
    Complete: 'TERMINER',
    DONE: 'TERMINÉ',
    Utillity: 'Utilitaire',
    AllUtilityService: "Tout le service d'utilitaire",
    Weather: 'Météo',
    WeatherServices: 'Services météorologiques',
    Weatherdata:
      'Les données météorologiques peuvent être intégrées en liant vos comptes',
    CONFIGURE: 'CONFIGURER',
    METERID: 'ID DU COMPTEUR',
    SERVICETYPE: 'TYPE DE SERVICE',
    METERINGPURPOSE: 'BUT DU COMPTAGE',
    SITESETTINGS: 'Paramètres du site',
    SERVICESINTEGRATION: 'Services',
    USERMANAGEMENT: 'Gestion des utilisateurs',
    GENERALSETTINGS: 'Paramètres généraux',
    UTILITYBILLTOOLTIPHEADER: 'Facture utilitaire',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Performance des utilitaires',
    ELECTRICITYTOOLTIPHEADER: "Économies d'énergie sur l'électricité",
    WATERTOOLTIPCONTENT:
      "Comparaison de la consommation d'eau pour la durée sélectionnée à partir d'informations réelles en regard des données de l'année de référence",
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      "Coût calculé pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. Remarque - Le coût est calculé sur la base des mois calendaires et non des périodes de facturation des services.",
    UTILITYBILLTOOLTIPCONTENT:
      "Consommation et coût calculés pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. Remarque - Le coût est calculé sur la base des mois calendaires et non des périodes de facturation des services.",
    CARBONTOOLTIPCONTENT:
      "Émissions calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. ",
    DATANEEDEDCONTENT:
      'Données de scope 1 manquantes, vérifier et mettre à jour les données chaque mois',
    CARBONTOOLTIPSECONDCONTENT:
      'Les calculs de CO2 en temps réel sont basés sur le compteur principal, et les calculs précis du carbone sont mis à jour après génération des factures de services.',
    CARBONTOOLTIPSUTILITY:
      "Émissions calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. Les calculs des émissions de carbone réelles sont basés sur la facture de services fournie.",
    CARBONTOOLTIPLIVE:
      "Émissions calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente provenant du compteur sur site. Les calculs de CO2 en temps réel sont basés sur le compteur principal.",
    CARBONTOOLTIPINTRVAL:
      "Émissions calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. Les calculs effectifs des émissions de carbone sont basés sur les données d'intervalle des services.",
    ELECTRICITYTOOLTIPCONTENT:
      "Économies d'électricité calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année de référence",
    DATANEEDED1:
      'Données insuffisantes - Les données de portée 1 doivent être mises à jour tous les mois.',
    GASTOOLTIPCONTENT:
      "Économies de gaz calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année de référence",
    ALLTOOLTIPCONTENT:
      " Économies calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année de référence",
    UTILITYVIEWDETAILSTOOLTIP:
      "Consommation et coût calculés pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. Remarque - La consommation et le coût sont calculés sur la base des mois calendaires et non des périodes de facturation des services.",
    EMAASENERGYUSAGETOOLTIP:
      "Consommation calculée pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année de référence",
    EMAASENERGYUSAGETOOLTIPPREV:
      "Consommation calculée pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente",
    EMAASCONSUMPTIONTOOLTIP:
      "Consommation calculée pour la durée sélectionnée en fonction des données réelles par rapport aux données de l'année de référence ou de l'année précédente",
    EMAASWATEROVERVIEWTOOLTIP:
      "Consommation calculée pour la durée sélectionnée en fonction des données réelles par rapport aux données de l'année précédente",
    EMAASNILMTOOLTIP:
      "Déterminer la répartition de la consommation d'énergie de votre site en fonction des types d'équipements",
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Économies de coûts totales sur les services énergétiques pour la durée sélectionnée',
    PORTFOLIOSUMMARYEUITOOLTIP:
      "L'EUI est un indicateur de l'efficacité énergétique de la conception et/ou du fonctionnement d'un bâtiment. L'EUI est mesurée comme l'agrégation énergétique du portefeuille divisée par le total de la surface du portefeuille en un an.",
    SITESUMMARYEUITOOLTIP:
      "L'EUI est un indicateur de l'efficacité énergétique de la conception et/ou du fonctionnement d'un bâtiment. L'EUI est mesurée comme agrégation énergétique du site au cours des 12 derniers mois, divisée par la zone brute totale du site.",
    PORTFOLIOSUMMARYEUITOOLTIPHEADER:
      "EUI (Intensité de consommation d'énergie)",
    SUMMARYEUITOOLTIPHEADERFORSITE:
      "EUI (intensité de consommation d'énergie) - {date}",
    PROVIDERLISTPLACEHOLDER: 'Rechercher les coordonnées du fournisseur',
    PORTFOLIOSUMMARYHEADER: "Aperçu du carbone et de l'énergie",
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Dernière mise à jour le {date}',
    AIModelDetails: 'Détails du modèle IA',
    DATAUPLOAD: 'Chargement des données',
    ADDFUEL: 'Ajouter un carburant',
    ADD: 'Ajouter',
    ADDCOMPOUND: 'Ajouter un composé',
    ADDMETEREDGAS: 'Ajouter du gaz mesuré',
    ADDSCOPETWO: 'Ajouter scope 2',
    EXCEEDEDLIMIT: 'limite max. dépassée de 4',
    DETAILS: 'Détails',
    DATAUPLOADDETAILS:
      'Accéder à toutes les fonctions qui requièrent une entrée manuelle/un chargement de fichiers de données.',
    DATAUPLOADCECARDSUBTITLE:
      "Suivre l'utilisation des émissions de carbone de scope 1 afin d'atteindre les objectifs de performance de développement durable de votre société.",
    DATAUPLOADCARBONESUBTITLE:
      "Cette page affiche un tableau complet qui présente les différents combustibles, leurs quantités correspondantes et les facteurs d'émissions de carbone associés pour l'année sélectionnée.",
    SCOPEONETWOSUBTITLE:
      "Cette page affiche un tableau détaillé qui présente les émissions de scope 1 (émissions directes, y compris la combustion stationnaire et les frigorigènes) et de scope 2 (émissions indirectes dues à l'électricité) ainsi que leurs quantités et leurs facteurs d'émissions carbone associés pour l'année choisie.",
    METERDATASUBHEADER:
      'Accéder à tous vos fichiers de données chargés pour les données des compteurs.',
    DATAMISSINGALERTS: 'Alertes pour données manquantes',
    UPLOAD: 'Chargement groupé',
    UPLOADTOPADD: 'Charger le fichier',
    PUBLISHFILE: 'Publier',
    BASELINEFILE: 'Niveau de référence',
    BASELINE_SUCCESS: 'Entraînement de référence initiée avec succès',
    UPLOADTOP: 'Charger',
    UPLOADFILE: 'CHARGER',
    NAME: 'Nom',
    DATATYPE: 'Type de données',
    CREATEDON: 'Créé le',
    DATEOFUPLOAD: 'Date du chargement',
    ALLUPLOADS: 'Tous les chargements',
    STATIONARYCOMBUSTION: 'Combustion stationnaire',
    REFRIGERANTS: 'Réfrigérants',
    WHEATHERDATA: 'Données météorologiques',
    UTILITYBILL: 'Facture de services',
    SCOPE2: 'Scope 2',
    METEREDGAS: 'Gaz mesuré',
    NOFILESADDEDHEADER: "Aucun fichier n'a encore été ajouté.",
    NOFILESADDEDMESSAGE:
      'Commencer en chargeant les données météorologiques, de services ou ponctuelles',
    UPLOADBUTTON: 'CHARGER',
    METER_DATA: 'Données du compteur',
    UTILITY_BILL: 'Facture de services',
    FUEL_NAME: 'Nom du carburant',
    SEARCHFOR: 'Rechercher',
    EnergyManagementSiteDashboardPortfolioTitle:
      "Présentation du carbone et de l'énergie",
    CHOOSEDATATYPEMESSAGE:
      "Choisissez ci-dessous le type de données pour télécharger le modèle, puis passez à l'étape suivante pour charger les fichiers.",
    UPLOADMETERDATASTEPONEMESSAGE:
      'Étape 1 : télécharger le modèle de données du compteur',
    UPLOADMETERDATA: 'Charger les données du compteur',
    FILEUPLOADNOTE:
      'Remarque : fichier {type} accepté uniquement ; et chaque fichier ne doit pas dépasser {size} Mo.',
    UPDATEDFILEUPLOADNOTE:
      'Remarque : seuls les fichiers CSV sont acceptés et chaque fichier ne doit pas dépasser 5 Mo.',
    INSTRUCTIONSFORFILLINGTHETEMPLATE:
      'Instructions pour le chargement du modèle.',
    INSTRUCTIONTEMPLATEONE:
      "Commencez par charger des données historiques des mesures de compteur à l'aide du modèle CSV fourni.",
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      "Veuillez vérifier que les valeurs des données chargées sont dans l'unité configurée dans RBM pour les compteurs",
    INSTRUCTIONTEMPLATEFIVE:
      "L'utilisateur peut charger 10 fichiers au maximum pendant le processus de chargement, pour un total combiné des tailles des fichiers ne dépassant pas 1,5 Go.",
    INSTRUCTIONTEMPLATETWO:
      "L'utilisateur peut charger des données pour un maximum de 2 ans avec un intervalle de 1, 3, 5 ou 15 minutes, pour une taille de fichier jusqu'à 1,5 Go",
    INSTRUCTIONTEMPLATETHREE:
      'Veuillez noter que le tableau de bord et les rapports afficheront les données historiques de compteur des 15 derniers jours et toutes les données de compteur chargées seront utilisées pour entraîner un modèle de référence de bonne qualité',
    INSTRUCTIONTEMPLATEFOUR: "Voir l'exemple de modèle CSV rempli",
    UPLOAD_PROGRESS_IN_TOAST:
      "Les progrès du téléchargement peuvent être constatés dans le widget en bas de l'écran.",
    PUBLISHMODALHEADER: 'Prêt à publier ?',
    ERRORINPUBLISHING:
      'Une erreur est survenue lors de la publication des fichiers. Veuillez réessayer ultérieurement',
    WARNINGNOTIFICATIONFORPUBLISH:
      'Des fichiers supplémentaires sont en cours de chargement',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      'Préférez-vous attendre avant de publier ou continuer à publier les fichiers {filesToPublish} ?',
    NOTEFORPUBLISHFILE:
      'Remarque : vous serez averti par e-mail une fois la publication terminée. Les données historiques du compteur seront affichées pour les 15 derniers jours uniquement dans le tableau de bord/les rapports.',
    INSTRUCTIONFORPUBLISHFILE: 'Voulez-vous publier les fichiers chargés ?',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE: 'Download Meter Data CSV Template',
    PUBLISHBUTTON: 'Oui, publier',
    METERDATAPUBLISHINGMSG:
      'Veuillez patienter pendant la publication des données. Vous serez averti par e-mail une fois la publication terminée.',
    METERDATAUPLOADFAILED:
      'Échec du chargement du fichier : {fileName}. Veuillez réessayer ultérieurement',
    METERDATAUPLOADSUCCESS: 'Fichier : {fileName} chargé avec succès',
    NOBUTTON: 'Non',
    METERUPLOADINSTRUCTIONTITLE:
      'Instructions pour le chargement des données de compteur',
    METERUPLOADDOWNLOADCSV: 'Télécharger le modèle CSV',
    METERUPLOADDOWNLOADEXCEL: ' Télécharger le modèle CSV',
    METERUPLOADINSTRUCTIONONE:
      "Commencez par charger des données historiques des mesures de compteur à l'aide du modèle CSV fourni. ",
    METERUPLOADINSTRUCTIONFOUR:
      "S'assurer que les données téléchargées du superviseur ne dépassent pas 1,5 Go. Veuillez vous référer aux préférences de taille de données fournies. ",
    METERDATAEXCELDOWNLOAD: 'Télécharger le fichier Excel des estimations',
    METERUPLOADINSTRUCTIONTWO:
      'Après avoir téléchargé des fichiers CSV pour tous les compteurs site/souhaités, cliquez sur le bouton « Publier » pour traiter et transférer les données historiques.',
    METERUPLOADINSTRUCTIONTHREE:
      'Pour établir une référence, cliquez sur "Action de référence" et spécifiez la plage de données souhaitée. Forge AI entraînera la référence en utilisant les données historiques disponibles publiées.',
    CHOOSEDATATYPE: 'Choisir le type de données',
    NEXTUPLOAD: 'Suivant-Charger',
    UPLOADDATA: 'Charger les données',
    ADDNEWFUEL: 'Ajouter un nouveau carburant à',
    ADDNEWCOMPOUND: 'Ajouter un nouveau composé à',
    MANUALINPUT: 'ENTRÉE MANUELLE',
    UPLOADDATACAPS: 'CHARGER LES DONNÉES',
    ADDNEWFUELSUB:
      'Choisir parmi les options suivantes pour saisir manuellement ou charger un modèle',
    SCOPEONESC: 'Combustion stationnaire : ajouter du carburant',
    SCOEONEREF: 'Fluides de réass. : ajouter un composé',
    SCOPETWO: 'Scope 2',
    UPLOADING: 'Chargement',
    FILES: 'fichiers',
    FILE: 'fichier',
    UPLOADINGMESSAGE1:
      "Les informations sur la progression du chargement et sur l'état de ces fichiers sont visibles dans la notification temporaire située en bas de l'écran.",
    REDIRECTMESSAGE1: 'Vous serez redirigé dans',
    REDIRECTMESSAGE1OCR: 'Vous serez bientôt redirigé',
    REDIRECTMESSAGE2: 's.',
    UPLOADFILES: 'Charger des fichiers pour',
    UPLOADMETERDATASTEPTWOMESSAGE:
      'Étape 2 : charger les fichiers pour les données de compteur',
    UPLOADNOTE:
      'Fichier {type} accepté uniquement ; et chaque fichier ne doit pas dépasser {size} Mo',
    UPDATEDUPLOADNOTE:
      'Un seul fichier CSV est accepté et le fichier ne doit pas dépasser 1,5 Go',
    UPDATEDUPLOADNOTESUB: '(un seul chargement possible à la fois)',
    INSTRUCTIONBUTTON: 'Exemple de modèle CSV rempli',
    FILEUPLOADPLACEHOLDER: 'Glisser-déposer les fichiers ici',
    SINGLEFILEUPLOADPLACEHOLDER: 'Glisser-déposer le fichier ici',
    TOTALSIZEEXCEEDSERROR: 'La taille totale dépasse la limite (1,5 Go)',
    NUMBEROFFILEALLOWED: "Vous pouvez charger jusqu'à 10 fichiers",
    FILEUPLOADPLACEHOLDERONLYONEFILE: '(un seul chargement possible à la fois)',
    REMOVE: 'Retirer',
    CHOOSESERVICE: 'Choisir le service',
    CONNECT: 'Connecter',
    NEXT: 'Suivant',
    CHOOSEUTILITYTYPE:
      "Sélectionner un fournisseur de services, les informations d'identification et les détails du compte pour intégrer les données.",
    CHOOSEUTILITYTYPEMANUAL:
      'Saisir le fournisseur de services et les détails du compte pour charger les données des services manuellement.',
    EDITDETAILNOTE:
      'Saisissez les détails corrects du compte et du compteur ci-dessous. Cliquez ensuite sur « Soumettre » pour les mettre à jour et les enregistrer.',
    EDITDETAILWHENBILLEXISTS:
      'Saisissez les détails corrects du compte et du compteur ci-dessous. Cliquez ensuite sur « Soumettre » pour les mettre à jour et les enregistrer.',
    SEARCHPROVIDER: 'Rechercher le fournisseur de services',
    CONTACTSUPPORT:
      "Impossible de trouver le fournisseur d'utilitaire ? Veuillez contacter l'équipe d'assistance Honeywell.",
    UTILITYPROVIDERLABEL: 'Fournisseur de services',
    SERVICEPROVIDERNAME: 'FOURNISSEUR DE SERVICES',
    INTEGRATIONTYPENAME: "TYPE D'INTÉGRATION",
    UTILITYSERVICES: 'Services',
    UtilityHandoffNotification:
      "Le type d'intégration du compte de services {manualCount} peut être converti du mode « manuel » au mode « automatisé ». Cela permet de mettre à jour automatiquement les factures de services sans aucune action nécessaire de votre part. Rechercher l'option dans le menu « Actions » dans le tableau ci-dessous.",
    UTILITYSERVICESDETAILS:
      'Intégrez et gérez vos multiples services pour utiliser rapidement et intelligemment les données de façon automatique.',
    ADDUTILITYSERVICE: 'Ajouter un service',
    ADDUTILITYTYPE: "Type d'intégration de services",
    AUTOMATEDTEXT:
      "Veuillez fournir vos informations d'identification pour le compte du « Fournisseur d'utilitaire » afin de permettre la récupération automatique mensuelle des données de votre facture utilitaire.",
    MANUALTEXT:
      "Si vous n'avez pas d'informations d'identification pour votre fournisseur de services et vous devez mettre à jour manuellement vos informations de facture utilitaire tous les mois.",
    MANUAL: 'Manuel',
    AUTOMATED: 'Automatisé',
    ADD_UTILITY_SERVICE: "Ajouter un service d'utilitaire",
    UTILITYTYPES: 'Types d’utilitaires',
    NOACCOUNTADDEDHEADER: "Aucun compte utilitaire n'a encore été ajouté.",
    NOACCOUNTADDEDMESSAGE:
      'Commencer en associant des comptes pour gérer les factures et les tarifs',
    ADDACCOUNTNUMBER: 'Ajouter',
    SELECTUTILITY: 'Sélectionner un service',
    ACCNUMBER: 'Numéro de compte*',
    UTILITYPROVIDERERROR:
      "Fournisseur de services non trouvé. Veuillez contacter votre manager Honeywell pour obtenir de l'aide lors de la conversion de ce compte",
    PASSWORD: 'Mot de passe*',
    USERNAME: "Nom d'utilisateur*",
    SIGNIN: 'Se connecter',
    UTILITYPROVIDERTOOLTIPTXT:
      "Saisir le nom du fournisseur d'utilitaire tel que mentionné sur la facture utilitaire.",
    VERIFICATIONINPROCESS: 'Vérification en cours',
    VERIFICATIONMSSG1:
      'Le processus de vérification du compte prend 2 à 3 jours.',
    UPDATECREDENTIALS: 'Mettre à jour les identifiants',
    UPDATECREDENTIALSNOTE:
      'Veuillez saisir le mot de passe à jour de votre « Nom de fournisseur de services » pour activer votre compte.',
    ENTERCREDENTIALS: 'Saisir les identifiants',
    ENTERCREDENTIALSNOTE:
      'Veuillez utiliser les identifiants de votre « Nom de fournisseur de services » pour lier le compte.',
    PLEASEUSESERVICE:
      'Veuillez utiliser les identifiants de votre « Fournisseur de services » pour lier le compte.',
    FILEEMPTYERRORMSG:
      'Erreur ! Le fichier est vide, veuillez charger à nouveau.',
    FILESIZEERRORMSG:
      'La taille du fichier dépasse 50 Mo. Veuillez réduire la taille du fichier et essayer à nouveau.',
    FILEMAXSIZEERRORMSG:
      'La taille du fichier dépasse {maxSize}. Veuillez réduire la taille du fichier et essayer à nouveau.',
    FILEHEADERERROR:
      'Le fichier possède des en-têtes non valides. Veuillez utiliser le modèle fourni et charger à nouveau.',
    CSVFILEINVALID:
      'Les données/le nom du fichier CSV chargé ne sont pas valides. Veuillez vérifier le fichier et essayer à nouveau.',
    CSVFILEINVALIDNAME:
      "Le fichier CSV chargé n'est pas valide. Les caractères spéciaux ou extensions multiples ne sont pas autorisés.",
    DEACTIVATEACCOUNT: 'Désactiver le compte',
    DEACTIVATEUDSACCOUNT: 'Désactiver le service de données mensuelles',
    DEACTIVATEIDSACCOUNT: 'Désactiver IDS (Interval Data Service)',
    REACTIVATEACCOUNT: 'Réactiver le compte',
    REACTIVATEIDSACCOUNT: 'Réactiver le service de données d’intervalle',
    CONVERTTOAUTOMATIC: 'Conversion en « automatique »',
    MANAGEBILLDETAILS: 'Gérer les détails de la facture',
    MANAGETARIFFDETAILS: 'Gérer les tarifs',
    EDITACCOUNTDETAILS: 'Modifier les détails du compte',
    EDIT_ACCOUNT_DETAILS: 'Modifier les détails du compte',
    ADD_METER: 'Ajouter un compteur',
    UTILITY_TYPES: 'Types d’utilitaires',
    CONVERT_INTEGRATION_TYPE: "Convertir le type d'intégration",
    ACCOUNT_NUMBER: 'Numéro de compte',
    BILLING_CYCLE: 'Cycle de facturation',
    PERIOD: 'Période',
    EDITACCOUNTDETAILSTOOLTIP:
      "L'utilisateur est autorisé à modifier tous les champs s'il n'y a pas de factures chargées.",
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      "L'utilisateur est autorisé à modifier le numéro du compte",
    CONVERTINTRGRATIONTYPE: 'Conversion en « automatique »',
    ENABLEIDS: 'Activer IDS (Interval Data Service)',
    DELETE: 'Supprimer',
    DELETING: 'Suppression',
    DEACTIVATECONFIRMATIONNOTE:
      'Voulez-vous vraiment désactiver le numéro de compte',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      'Êtes-vous sûr de vouloir désactiver IDS (Interval Data Service) pour le numéro de compte',
    REACTIVATECONFIRMATIONNOTE:
      'Voulez-vous vraiment réactiver le numéro de compte ?',
    REACTIVATEIDSCONFIRMATIONNOTE:
      'Êtes-vous sûr de vouloir réactiver IDS (Interval Data Service) pour le numéro de compte',
    DEACTIVATEUTILITYACCOUNTMSSG:
      "Une fois le compte désactivé, l'application n'extraira pas automatiquement les informations de la facture de services et seules les informations de l'historique seront enregistrées.",
    DEACTIVATEIDSACCOUNTMSSG:
      'Une fois IDS désactivé, l’application n’extraira pas automatiquement les données d’intervalle des services et seules les données historiques seront stockées.',
    REACTIVATEUTILITYACCOUNTMSSG:
      "Une fois le compte réactivé, l'application extrait automatiquement les informations de la facture de services.",
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      'Une fois le compte réactivé, l’application extraira automatiquement les données d’intervalle des services.',
    YES: 'Oui',
    NO: 'Non',
    REVERIFYNOTE:
      'Veuillez saisir les identifiants de votre « Fournisseur de services » pour lier le compte.',
    REVERIFYHEADER: 'Vérifier les identifiants et le numéro de compte',
    REVERIFY: 'Revérifier',
    UPDATE: 'Mettre à jour',
    REENROLL: 'Réactiver le compte',
    save: 'ENREGISTRER',
    ACCOUNTMISSINGHEADER: 'Mettre à jour le numéro de compte',
    ACCOUNTMISSINGNOTE:
      'Veuillez saisir vos identifiants de « Fournisseur de services » et votre numéro de compte pour lier le compte.',
    SHOWMORE: 'Afficher plus',
    NORESULTS: 'Aucun résultat trouvé.',
    BREAKDOWNBYSITE: 'Répartition par site ({count})',
    PORTFOLIOENERGY: 'Énergie',
    PORTFOLIOENERGYCONS: 'Conso énergie',
    PORTFOLIOCONSUMTION: 'Consommation',
    PORTFOLIOWATER: 'Eau',
    PORTFOLIOWATERCONS: "Cons. d'eau",
    ENERGYUSAGEBYSITE: "Consommation d'énergie par site ({count})",
    SITEWITHDATA:
      '* Seuls les sites avec des données sont affichés dans le tableau',
    ELECTRICITYUSAGEBYSITE: "Consommation d'électricité par site ({count})",
    GASUSAGEBYSITE: 'Consommation de gaz par site ({count})',
    WATERUSAGEBYSITE: "Consommation d'eau par site ({count})",
    ENERGYOPTIMIZATION: 'Optimisation intelligente de bâtiment',
    ENERGYOPTIMIZATIONNEW: 'Energy Optimization',
    ENERGYOPTIMIZATIONEO: 'Optimisation intelligente de bâtiment (IBO)',
    ENERGYOPTIMIZATIONSAVINGS: 'Économies IBO',
    EOSETTINGSUBTITLE:
      "L'EO permet de surveiller, de mesurer et d'optimiser en permanence les CVC dans les bâtiments, avec une consommation d'énergie des plus faibles dans toutes les situations, minimisant ainsi l'énergie réservée au chauffage et à la climatisation d'une installation et de façon continue.",
    EOSETTINGMODALHEADER: 'Energy Optimization inactif ?',
    EOSETINGMODALCONTENT:
      "L'optimisation intelligente de bâtiment ne surveillera, ne mesurera et n'optimisera pas de façon continue les CVC dans votre installation pour une consommation d'énergie des plus faibles.",
    EOSETINGMODALCONTENTSUB:
      "Voulez-vous vraiment désactiver l'optimisation d'énergie (EO) ?",
    EOENABLETITLE: "Activer l'optimisation énergétique pour ce site.",
    EOSTATUSMESSAGESUCCESS:
      'Optimisation intelligente de bâtiment activée pour ce site avec succès.',
    EOSTATUSMESSAGEERROR:
      'Optimisation intelligente de bâtiment désactivée pour ce site avec succès.',
    EOSETTINGNODATAAVAILABLE:
      "Veuillez contacter l'administrateur du système, la configuration n'est pas terminée.",
    CURRENTEOSTATUS: "État d'EO actuel : ",
    ON: 'Activé',
    OFFMANUALSWITCHEDOFF: 'Désactivé-Désactivé manuellement',
    OFFLINE: 'Hors ligne',
    EONotOptimizing: 'EO non optimisé',
    OFFPLANNEDOFFFORIMPROVINGBASELINE:
      'Désactivé-Arrêt prévu pour amélioration de la référence',
    SwitchedOfffromCloud: 'Désactivé depuis le Cloud',
    SwitchedOfffromSite: 'Désactivé depuis le site',
    EOON:
      "L'état EO actif indique que la stratégie d'optimisation actuelle est utilisée",
    EOMANUALSWITHCHEDOFF:
      "le point de consigne n'a pas été appliqué depuis que l'EO a été désactivé manuellement",
    PLANNEDOFFFORBASELINE:
      "La désactivation de l'EO est prévue pour l'amélioration de la référence",
    STATUSNOTAVAILABLE: 'Statut non disponible',
    STATUSNOTAVAILABLETOOLTIP:
      "Les détails de l'état ne sont pas disponibles pour le moment. Veuillez contacter l'équipe d'assistance Honeywell - connectedbuildingsupport@honeywell.com pour résoudre cette condition",
    EOOFFLINE:
      "L'état EO inactif indique qu'une stratégie d'optimisation n'est pas utilisée en raison d'un échec de l'optimisation",
    SwitchedOfffromCloudToolTip:
      "L'optimisation énergétique est désactivée manuellement depuis le cloud. Veuillez contacter l'équipe de support Honeywell - connectedbuildingsupport@honeywell.com - pour réactiver l'optimisation énergétique.",
    SwitchedOfffromSiiteToolTip:
      "L'optimisation énergétique est désactivée manuellement par l'utilisateur sur le site.",

    EOSavings: " Économies d'optimisation de la construction intelligente",
    EOUtility_all: 'Tous les services',
    EOUtility_electricity: 'Électricité',
    EOUtility_gas: 'Gaz',
    EOUtility_steam: 'Vapeur',
    EOUtility_chilledwater: 'Eau froide',
    EOUtility_hotwater: 'Eau chaude',
    inactiveDays: 'Jours inactifs',
    inactiveDay: 'Jour inactif',
    excludedDays: "Jours d'exclusion",
    excludedDay: "Jour d'exclusion",
    activeHours: 'Heures actives',
    activeDay: 'Jour actif',
    savingsSummaryEO:
      "Économies estimées (avec {opertionalPercentage} % de durée opérationnelle d'EO)",
    operationalTimeEO:
      "Avec {opertionalPercentage}% de temps opérationnel d'EO",
    timeUsedForBaselining:
      '{baseline} % du temps utilisé pour établir la référence',
    siteComfort: 'Confort du site',
    activeStrategyStatus: 'Actif',
    inactiveStrategyStatus: 'Inactif',
    lastUpdated: 'Dernière mise à jour :',
    CALCULATED: 'Niveau de référence',
    ESTIMATEDSAVINGS: 'Économies prévues',
    OPPORTUNITYFROMEO: 'Opportunité d’EO',
    EMAASEOSTATETOOLTIP:
      "L'état actif ou inactif indique la stratégie d'optimisation actuellement en cours d'utilisation.",
    EOSAVINGTOOLTIP:
      "Économies d'énergie réalisées lors de l'exécution de Intelligent Building Optimization par rapport à la consommation d'énergie calculée.",
    EOSAVINGONENABLE: 'Économies sur les jours avec IBO activé',
    EOSAVINGENTIREPERIOD: "Économies sur l'ensemble de la période",
    EONEGATIVEORZEROSAVINGSMESSAGE:
      'Aucune économie dans la plage de temps sélectionnée. Pour connaître les économies prévues, songez à étendre la durée sélectionnée à une période plus longue.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      "Consommation calculée pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année de référence. L'EUI est calculée à partir de données énergétiques provenant des factures utilitaires.",
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      "Consommation calculée pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente. L'EUI est calculée à partir de données énergétiques provenant des factures de services.",
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      "Consommation calculée pour la durée sélectionnée en fonction des données réelles par rapport aux données de l'année de référence ou de l'année précédente. L'EUI est calculée à partir de données énergétiques provenant des factures de services.",
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      "La consommation est calculée pour la période sélectionnée à partir des données réelles, comparée aux données précédentes ou de référence pour les services et le compteur en direct, respectivement. La consommation mensuelle est basée sur la consommation d'énergie quotidienne moyenne provenant des factures de services, normalisée pour des mois complets lorsque la facture s'étend sur deux mois.",
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      'La consommation est calculée pour la période sélectionnée à partir des données réelles, par rapport aux données de référence provenant du compteur sur site.',
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      "La consommation est calculée pour la période sélectionnée à partir des données réelles, par rapport aux données de référence provenant des données d'intervalle des services.",
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      'La consommation est calculée pour la période sélectionnée à partir des données réelles, par rapport aux données précédentes provenant du compteur sur site.',
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      "La consommation est calculée pour la période sélectionnée à partir des données réelles, comparée aux données de la période précédente provenant des factures de services. La consommation mensuelle est basée sur la consommation d'énergie quotidienne moyenne provenant des factures de services, normalisée pour un mois complet lorsque la facture s'étend sur deux mois.",
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Modifier',
    PORTFOLIOSITECOUNT: 'Répartition par site ({count})',
    UTILITYCOSTBYSITES: 'Coût du service {Utility} par site ({count})',
    ALLUTILITYCOSTBYSITES: 'Coût des services par site ({count})',
    SOLAR: 'Solaire',
    WIND: 'Vent',
    SOLARPERFORMANCE: 'Performances solaires',
    WINDPERFORMANCE: 'Performances éoliennes',
    UTILITYCOSTOVERVIEW: 'Aperçu du coût des services',
    DESCRIPTIONNOTIFICATION:
      "Vous avez atteint le nombre maximal de comptes de services pour le même type de service. Contactez votre administrateur pour créer d'autres comptes.",
    TITLENOTIFICATION: 'Limite de comptes atteinte.',
    ENERGYUSAGECAPS: 'UTILISATION ÉNERGÉTIQUE',
    UPDATEERRORMESSAGE: 'Un problème est survenu. Réessayez ultérieurement.',
    MANUALTOAUTOMATICCONVERSION:
      'La conversion du compte du mode manuel à automatique a été mise en œuvre avec succès.',
    APPLY: 'APPLIQUER',
    RESET: 'RÉINITIALISER',
    CLOSE: 'FERMER',
    SCOPE1FUELTYPES: 'Types de carburant de scope 1',
    SCOPE1FILTERSUBHEADER: 'Le filtre change uniquement la vue graphique',
    SCOPE1DATAMISSING: 'Données de scope 1 manquantes',
    SCOPE1SHOWMISSINGDATA:
      'Veuillez vérifier les données manquantes de scope 1 et mettez à jour',
    FUELGASTYPE: 'Type de carburant/gaz',
    COMPOUNDTYPE: 'Type de composé',
    UTILITYTYPE: 'Type de service',
    FUELGASTYPESELECT: 'Sélectionner un type de carburant/gaz',
    COMPOUNDSELECT: 'Sélectionner le type de composé',
    UTILITYSELECT: "Sélectionner le type d'utilitaire",
    EMISSIONFACTOR: "Facteur d'émission de CO2",
    SelectCategory: 'Sélectionner la catégorie',
    UNIT: 'Unité',
    UNITSELECT: 'Sélectionner une unité',
    StationaryCombustion: 'Combustion stationnaire',
    YEAR: 'Année',
    Country: 'Pays',
    State: 'État',
    YEARSELECT: 'Sélectionner une année',
    MONTH: 'Mois',
    Override: 'Écraser',
    MONTHSELECT: 'Sélectionner un mois',
    ADDDATA: 'Ajouter des données',
    NOFUELCONSUMED: 'Aucun carburant consommé ',
    NOCONSUMED: 'Aucune consommation',
    QUANTITY: 'Quantité',
    QUANTITYENTER: 'Entrer la quantité',
    COSTSCOPE: 'Coût',
    COSTENTER: 'Entrer le coût',
    EDIT: 'Modifier',
    YEARCHECK: 'an',
    MONTHERROR: 'Sélectionner un mois différent',
    SUCCESS: 'Données mises à jour avec succès',
    CO2FACTORROOLTIPHEADER: "Facteur d'émission de CO2",
    PLEASENOTE: 'Remarque : ',
    PLEASENOTETEXT:
      "Le nouveau facteur d'émissions de carbone sera utilisé dans le prochain calcul des émissions de carbone. Les valeurs d'émissions de carbone déjà calculées ne seront pas recalculées en utilisant la nouvelle valeur.",
    CO2FACTORROOLTIPCONTENT:
      "Il s'agit de la quantité de CO2 libéré dans l'atmosphère par unité d'énergie utilisée",
    CO2FACTORSCCONTENT:
      "Il s'agit de la quantité de CO2 libéré dans l'atmosphère par unité d'énergie utilisée. Pour l'unité sélectionnée, entrez la valeur équivalente en kgCo2e/mmbtu.",
    CO2FACTORRFCONTENT:
      "Il s'agit de la quantité de CO2 libéré dans l'atmosphère par unité d'énergie utilisée. Pour l'unité sélectionnée, entrez la valeur équivalente en MTCo2e/mmbtu.",
    CO2FACTORSCOPETWOANDGASCONTENT:
      "Il s'agit de la quantité de CO2 libéré dans l'atmosphère par unité d'énergie utilisée. Entrer la valeur équivalente pour l'unité sélectionnée.",
    FUELTABLETEXT:
      'Les types de carburants ci-dessous font partie des émissions de scope 1',
    METEREDGASHEADER:
      "Les types d'utilitaires ci-dessous font partie des émissions de scope 1",
    SCOPETWOHEADER:
      "Les types d'utilitaires ci-dessous font partie des émissions de scope 2",
    UNITDROPDOWNNAME: 'Unité',
    COMPOUNDTABLETEXT:
      'Les types de composés ci-dessous font partie des émissions de scope 1',
    ENERGYCONSUMPTIONNILM: "Consommation d'énergie",
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      "Le graphique montre la consommation d'énergie et sa répartition sur la période sélectionnée",
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE:
      "Consommation d'énergie par type d'équipement",
    METERNAME: 'Nom du compteur*',
    METERNUMBER: 'Numéro de compteur*',
    CONSUMPTIONUNIT: 'Unité de consommation',
    DEMANDUNIT: 'Unité de demande',
    CURRENCYUNIT: 'Unité de devise',
    TOTALMETERS: 'TOTAUX COMPTEURS',
    METERNAMECHANGEDESCRIPTION:
      'Ci-dessous se trouve la liste des ID de compteur associés au compte',
    METERNAMEUPDATESUCCESS:
      'ID du compteur : ({meterId}) a été renommé avec succès en « ({meterName}) »',
    METERNAMECHARACTERS: 'Utiliser uniquement des caractères alpha numériques',
    METERNAMEMAXLENGTH: 'Longueur max. : {maxCh} caractères',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Aperçu de la consommation ({rate})',
    DEMAND_OVERVIEW: 'Aperçu de la demande {rate}',
    DEMAND: 'Demande',
    CONSUMPTION_RATE_OVERVIEW: '{name} Présentation ({rate})',
    ELECTRICITYBLENDEDRATE: "Taux d'électricité mixte ({rate})",
    BILLBREAKDOWN_COST_OVERVIEW:
      '{utilityName} Présentation des coûts ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: "Coût de l'électricité ({rate})",
    COST: 'Aperçu de la consommation',
    SUMMARY: 'Résumé',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Gérer les colonnes',
    RESET_ALL_FILTERS: 'Réinitialiser tous les filtres',
    DOWNLOAD_CSV: 'Télécharger le CSV',
    DOWNLOAD_PDF: 'Afficher et télécharger le PDF',
    UTILITY_BILL_ANALYSIS: 'Analyse de facture {utilityName}',
    NOTIFICATIONBOXFORMONTHLY:
      "L'analyse de la facture d'électricité comprend des vues mensuelles et sur la période de facturation.  La vue mensuelle calcule la facture de services du début à la fin du mois, au prorata. Exemple (du 1er mai 2022 au 31 mai 2022). Alors que la vue de la période de facturation calcule la facture d'électricité selon le cycle de facturation effectif. Exemple (du 22 mai 2022 au 22 juin 2022). Cliquez sur la période de facturation pour afficher les données selon le cycle de facturation réel.",
    SUMMARYTABLEAPIONGOING:
      'Les appels dans le tableau récapitulatif sont en cours de traitement en lot, veuillez cliquer après que toutes les données du tableau ont été chargées.',
    NOTIFICATIONFORBILLINGPERIOD:
      'La vue de la période de facturation calcule la facture de services en suivant le cycle de facturation réel. Exemple (du 22 mai 2022 au 22 juin 2022).',
    VIEW_OVERVIEW: "Afficher la vue d'ensemble",
    FILE_DELETED_SUCCESSFULLY: 'Suppression du fichier réussie',
    FILE_DELETEING_ERROR:
      'Erreur lors de la suppression du fichier. Veuillez réessayer ultérieurement.',
    AVG_CONSUMP_PER_MTH: 'Consommation moy. par mois',
    AVG_CONSUMP_PER_DAY: 'Consommation moy. par jour',
    MTHLY_CONSUMP_PER_SQFT: 'Consommation mensuelle par pied carré',
    EnableIDSText:
      "Saisir les informations d'identification pour vérifier le compte. Cliquez sur Soumettre pour activer IDS.",
    EnableIDSHeaderTxt: 'Activer le service de données d’intervalle',
    EOSAVINGS: 'Économies EO',
    EOSUMMARY: 'Résumé EO',
    REASONFOROFFLINE: 'Reason for Off - Details'
  },
  alarmConfiguration: {
    ALARMTYPE: "Type d'alarme",
    CONFIGUREALARMDESCLINE1:
      "Sélectionner le type d'alarme pour les compteurs à configurer",
    CONFIGUREALARMDESCLINE2:
      "Sélectionnez le type d'alarme de compteurs pour activer les alarmes, si la consommation d'énergie dépasse la valeur de référence de la plage mentionnée.",
    ALLMETERS: 'Tous les compteurs ',
    SEARCHALARMTYPE: "Sélectionner le type d'alarme",
    SEARCHMETERS: 'Rechercher un compteur',
    THRESHOLDSETTINGS: 'RÉGLAGE DES SEUILS',
    NOMETERSSELECTED:
      'Sélectionnez au moins un compteur sur la gauche\nvolet permettant de modifier les valeurs des seuils.',
    THRESHOLDALARM: "SEUIL D'ALARME",
    ALARMNAME: "Nom de l'alarme",
    MINTHRESHOLD: 'Seuil minimum',
    MAXTHRESHOLD: 'Seuil maximum',
    TO: 'à',
    RESETTODEFAULTS: 'Restaurer les valeurs par défaut',
    SAVE: 'ENREGISTRER',
    NOMETERSUNDERSITE: 'Aucun compteur disponible',
    NOSITESAVAILABLE: 'Aucun site disponible',
    VALIDATIONREQUIRED:
      'Au moins une priorité doit être sélectionnée et toutes les entrées sous elle doivent être remplies',
    VALIDATIONOVERLAPPING:
      "Les données saisies ne sont pas valides ou se chevauchent avec d'autres valeurs"
  },
  urjanetStatus: {
    ENROLLED: 'Enregistré avec succès',
    ENROLLEDMSG: "L'extraction du compte a réussi",
    SUCCESSFUL_DELIVERED: 'Livré avec succès',
    SUCCESSFUL_DELIVEREDMSG:
      "L'extraction et la livraison du compte ont réussi",
    PRODUCTION: 'Production',
    PRODUCTIONMSG: 'Le compte est en production',
    Active: 'Actif',
    ACTIVEMSG:
      "Un compte manuel existe et l'utilisateur peut saisir des factures manuelles.",
    Enroll_Successful: 'Inscription réussie',
    FAILEDLOGIN: 'Échec de la connexion',
    NEEDSCREDENTIAL: 'Identifiants requis',
    NEEDSCREDENTIALMSG: "Le compte ne comporte pas d'identifiant associé",
    FAILEDTOACCESS: "Échec de l'accès.",
    NEEDSTEMPLATE: "Besoin d'un modèle",
    NEEDSTEMPLATEMSG:
      "Le compte possède un identifiant, mais cet identifiant n'a pas de modèle assigné",
    UNDERREVIEW: "En cours d'examen",
    UNDERREVIEWMSG: 'Échec avec état générique',
    WEBSITEISSUE: 'Problème du site Web',
    WEBSITEISSUEMSG: 'Le compte ne peut pas se connecter au site Web',
    CAPTCHALOGIN: 'Connexion Captcha',
    CAPTCHALOGINMSG: 'La connexion est bloquée par Captcha sur le site Web',
    TEMPLATEFAILURE: 'Échec du modèle',
    TEMPLATEFAILUREMSG:
      'Un problème avec le modèle a empêché une extraction réussie',
    NEEDSENROLLMENT: 'Inscription requise',
    NEEDSENROLLMENTMSG: 'Le compte doit être inscrit',
    NOBILL: 'Pas de facture',
    NOBILLMSG:
      "Le compte ne dispose d'aucune facture disponible sur le site Web",
    REENROLLED: 'Réinscrit',
    REENROLLEDMSG: 'Le compte est à nouveau inscrit après la désactivation',
    NAVIGATIONFAILURE: 'Échec de la navigation',
    NAVIGATIONFAILUREMSG: 'Correction du modèle requise pour ces comptes',
    SOURCEFORMATCHANGE: 'Changement de format de la source',
    SOURCEFORMATCHANGEMSG: 'Un nouveau format de facture a été détecté',
    ACCOUNTNUMBERCHANGE: 'Changement du numéro de compte',
    ACCOUNTNUMBERCHANGEMSG: 'Le numéro de compte a été remplacé par le nouveau',
    USERACTIONREQUIRED: 'Action utilisateur requise',
    USERACTIONREQUIREDMSG: 'Action requise du client',
    MIGRATION: 'Migration',
    MIGRATIONMSG:
      'Compte ayant migré avec le nouveau fournisseur/numéro de compte',
    INITIALTEMPLATEDEVELOPMENT: 'Développement du modèle initial',
    INITIALTEMPLATEDEVELOPMENTMSG: 'Le modèle est en cours de développement.',
    REJECTED: 'Rejeté',
    REJECTEDMSG:
      'Comptes refusés, car ils ne sont pas valides pour le traitement',
    EBILLENROLLMENT: 'Inscription à la facturation électronique',
    EBILLENROLLMENTMSG:
      "Compte pour lequel l'inscription à la facturation électronique est requise/en attente",
    CREDENTIALUPDATED: 'Identifiant mis à jour',
    CREDENTIALUPDATEDMSG:
      'Les identifiants ont été mis à jour après une défaillance, le processus de vérification du compte prend 2/3 jours.',
    TEMPLATEUPDATED: 'Modèle mis à jour',
    TEMPLATEUPDATEDMSG: "Le modèle a été mis à jour mais n'a pas été testé",
    UNKNOWN: 'Inconnu',
    UNKNOWNMSG: "L'état du compte est inconnu",
    PENDINGMSG: "L'état du compte est en attente",
    PENDING: 'En attente',
    DELETED: 'Supprimé',
    DELETEDMSG: 'Le compte a été supprimé',
    ENROLLMENTFAILUREMSG: "Échec de l'inscription du compte",
    ENROLLMENTFAILURE: "Échec de l'inscription",
    DOESNOTEXIST: "N'existe pas",
    DOESNOTEXISTMSG: "Le compte n'existe pas",
    ACCOUNTNUMBERMISMATCHMSG: 'Inadéquation du numéro de compte',
    ACCOUNTNUMBERMISMATCH: 'Inadéquation du numéro de compte',
    CONVERSIONINPROGRESS: 'Conversion en cours',
    CONVERSIONINPROGRESSMSG:
      'Conversion du compte en cours, du mode manuel au mode automatique',
    FAILEDTOACCESSMSG:
      "L'extraction n'a rien renvoyé (nouveau site Web ou navigation interrompue)",
    FAILEDTOACCESSMSGIDS:
      "Échec de l'accès aux données d'intervalle des services",
    FAILEDLOGINMESSAGE:
      "La navigation a échoué à l'étape de connexion spécifiquement (vérifier l'utilisateur/le mot de passe)",
    ACCOUNTMISSING: 'Compte manquant',
    ACCOUNTMISSINGMESSAGE:
      "Les identifiants ont été exécutés avec succès dans une certaine mesure, mais ce compte n'a pas été trouvé",
    CONNECTIONERROR: 'Erreur de connectivité',
    CONNECTIONERRORMESSAGE:
      'Une erreur est survenue, veuillez saisir à nouveau les identifiants du « Fournisseur de services » pour le compte.',
    CONNECTIONERRORMESSAGEIDS: 'Une erreur est survenue.',
    BLOCKED: 'Compte bloqué',
    BLOCKEDMESSAGE: 'Connexion bloquée.',
    INACTIVE: 'Compte inactif',
    INACTIVEMESSAGE: 'Le compte est inactif.',
    FINALLED: 'Compte fermé',
    FINALLEDMESSAGE:
      "Vérifiez le compte et désabonnez-le s'il n'est plus nécessaire de le traiter.",
    VERIFICATIONINPROG: 'Vérification en cours',
    VERIFICATIONINPROGIDS: 'Vérification en cours',
    REENROLLMENTPROG: 'Réinscription en cours',
    REACTIVATIONPROG: 'Réactivation en cours',
    SUBMITTED: 'Envoyé',
    SUBMITTEDMSG: 'État du compte initial ; doit se poursuivre automatiquement',
    NOMINATEDPROG: 'Nominé',
    METERSMISMATCHED: 'Incohérence des compteurs',
    METERSMISMATCHEDMSG:
      'Les détails des compteurs ne correspondent pas, veuillez mettre à jour dans Modifier les détails du compte.',
    VERIFICATIONINPROGMESSAGE:
      'Le processus de vérification du compte prend 2 à 3 jours.',
    VERIFICATIONINPROGMESSAGEIDS:
      'Le processus de vérification du compte prend 2 à 3 jours.',
    REENROLLMENTTOOLTIP:
      "L'action de réinscription sur ce compte est lancée à nouveau après la désactivation",
    REACTIVATIONTOOLTIP:
      "L'action de réactivation sur ce compte IDS est lancée à nouveau après la désactivation",
    NOMINATEDMESSAGE:
      "Le compte dispose d'un identifiant entièrement validé, mais qui n'a pas encore été utilisé",
    DATAUNAVAILABLE: 'Échec du relevé',
    STATEMENTMISSING: 'Relevé manquant',
    DATAUNAVAILABLEMESSAGE:
      " Un relevé a été extrait, mais n'a pas été conservé en raison de défaillances d'audit, de stockage, etc.",
    STATEMENTMISSINGMSG:
      "Les identifiants ont été utilisés avec succès et le compte a été consulté sur le site Web, mais nous n'avons pas pu extraire un relevé",
    NOTENROLLED: 'Non enregistré',
    NOTENROLLEDMESSAGE:
      "L'extraction du compte a réussi, mais le compte en question n'est pas abonné",
    DEACTIVATED: 'Désactivé',
    DEACTIVATEDMESSAGE: "Le compte n'est plus actif.",
    REVIEWACCOUNTANDUNS:
      "Vérifiez le compte et désabonnez-le s'il n'est plus nécessaire de le traiter",
    ERROR: 'Erreur',
    ERRORMESSAGE:
      'Un problème est survenu. Veuillez contacter votre administrateur.',
    LOGINFAILURE: 'Échec de connexion',
    LOGINFAILUREMESSAGE:
      "La connexion a échoué à cause de la modification du mot de passe ou de l'expiration du compte du fournisseur de services.",
    DEACTIVATIONINITIATEDMSSG: 'Désactivation initiée.',
    DEACTIVATIONINITIATED: 'Désactivation en cours',
    REENROLLEDREQUIRED: 'Réinscription requise',
    REENROLLEDREQUIREDMSG:
      "Une réinscription est requise pour le compte. Veuillez saisir à nouveau les informations d'identification en cliquant sur mise à jour.",
    ENABLEIDSMSG:
      "Le service de données d'intervalle (IDS) a été activé avec succès.",
    INTERVALSNOTSUPPORTED: 'Non pris en charge',
    INTERVALSNOTSUPPORTEDMSG:
      "Le service de données d'intervalle (IDS) n'est pas pris en charge par le fournisseur de services pour ce compte.",
    PLUGNEWACCOUNTMSG: 'Compte inscrit avec succès',
    PLUGEMAILAPPROVALMSG:
      'La vérification du compte est en cours et Arcadia nécessite l’approbation par e-mail du client',
    PLUGCREDENTIALISSUEMSG:
      'Échec de l’accès aux données d’intervalle des services en raison d’un problème d’identification',
    PLUGNODATAAVAILABLEMSG:
      'Échec de l’accès aux données d’intervalle des services en raison de l’absence de données',
    PLUGUNSUCCESSFULEMAILAPPROVALMSG:
      'Échec de l’accès aux données d’intervalle des services en raison d’un problème d’approbation par e-mail',
    PLUGINVALIDCREDENTIALSMSG:
      'Échec de la connexion en raison d’identifiants invalides'
  },
  virtualMeters: {
    SELECTED: "Compteurs d'électricité - sélectionnés ({count})",
    SEARCHMETERS: 'Rechercher le nom du compteur',
    METERGROUPDETAILS: 'DÉTAILS SUR LE GROUPE DE COMPTEURS',
    METERGROUPNAME: 'Nom du groupe de compteurs',
    DESCRIPTION: 'Description',
    DESCRIPTIONPLACEHOLDER: '240 caractères maximum',
    VALIDATIONREQUIRED:
      'Deux compteurs au moins doivent être sélectionnés et les deux entrées doivent être renseignées',
    SAVE: 'ENREGISTRER',
    CANCEL: 'ANNULER'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Total des émissions',
    TOTALEMISSION: 'Total des émissions',
    SCOPEONETITLE: 'Émissions de carbone par scope 1',
    SCOPETWOTITLE: 'Émissions de carbone par scope 2',
    SCOPE1: 'Scope 1',
    SCOPE2: 'Scope 2',
    SCOPEONEDATANOTCONSIDER: 'Les données de scope 1 doivent être mises à jour',
    CARBONTITLE: 'Aperçu des émissions de carbone',
    PORTFOLIOCARBONTITLE: 'Émissions de carbone (CO2e) du portefeuille',
    TOTALEMISSIONSTOOLTIP:
      "Émissions calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente.",
    CARBONTOOLTIPSUTILITYDETAIL:
      'Emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility bill provided.',
    CARBONTOOLTIPLIVEDETAIL:
      "Émission calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l'année précédente du compteur sur site. Les calculs C02 en temps réel sont basés sur le compteur principal.",
    CARBONTOOLTIPINTRVALDETAIL:
      "Émission calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l'année précédente. Les calculs C02 en temps réel sont basés sur les données d'intervalle.",
    SCOPEONETOOLTIP:
      "Émissions directes calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente.",
    SCOPETWOTOOLTIP:
      "Émissions indirectes calculées pour la durée sélectionnée, sur la base de chiffres réels liés aux données de l'année précédente.",
    SCOPEONETOOLTIPUTILITY:
      'Émission directe calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l’année précédente. Les calculs d’émissions de carbone réels sont basés sur la facture de services fournie.',
    SCOPEONETOOLTIPINTERVAL:
      'Émission directe calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l’année précédente. Les calculs d’émissions de carbone réels sont basés sur les données d’intervalle.',
    SCOPEONETOOLTIPLIVE:
      'Émission directe calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l’année précédente du compteur sur site. Les calculs C02 en temps réel sont basés sur le compteur principal.',
    SCOPETWOTOOLTIPdUTILITY:
      'Émission indirecte calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l’année précédente. Les calculs d’émissions de carbone réels sont basés sur la facture de services fournie.',
    SCOPETWOTOOLTIPINTERVAL:
      'Émission indirecte calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l’année précédente. Les calculs d’émissions de carbone réels sont basés sur les données d’intervalle.',
    SCOPETWOTOOLTIPLIVE:
      'Émission indirecte calculée pour la durée sélectionnée à partir de données réelles par rapport aux données de l’année précédente du compteur sur site. Les calculs C02 en temps réel sont basés sur le compteur principal.',
    CARBONDETAILKEY: 'carbondetail',
    SCOPEONEKEY: 'detailSummaryWithoutCurrency',
    UTILITYDETAILKEY: 'utilitydetail',
    METER: 'COMPTEUR',
    METERNAME: 'NOM DU COMPTEUR',
    FUELTYPE: 'TYPE DE CARBURANT',
    SITES: 'SITES',
    SOURCE: 'ÉMETTEUR',
    CURRENTAVOIDANCE: 'ÉVITEMENT ACTUEL',
    PREVIOUSAVOIDANCE: 'ÉVITEMENT PRÉCÉDENT',
    UTILITYTYPE: 'TYPE DE SERVICE',
    ACTUALEMISSION: 'ÉMISSIONS RÉELLES',
    ACTUALEMIS: 'ÉMIS. RÉELLES',
    PREVIOUSEMISSION: 'ÉMISSIONS PRÉCÉDENTES',
    PREVIOUSPERIOD: 'ÉMIS. PRÉCÉDENTES',
    PREVIOUSEMISSIONS: 'Émissions précédentes',
    PORTFOLIOPREVIOUSConsumption: 'PÉRIODE PRÉCÉDENTE',
    PORTFOLIOACTUALEMISSION: 'ÉMISSIONS RÉELLES',
    PORTFOLIOPREVIOUSEMISSION: 'ÉMISSIONS PRÉC.',
    PORTFOLIOPREVIOUSCOST: 'COÛT PRÉC.',
    CHANGE: 'MODIFIER',
    ACTUALCONS: 'CONSO RÉELLE',
    BASELINECONSP: 'CONSO DE RÉF.',
    PREVPERIOD: 'PÉRIODE PRÉC.',
    CHANGEPERCENT: '%CHANGEMENT',
    EUICURRENT: 'EUI RÉELLE',
    EUIPRVPERIOD: 'EUI PRÉC. PÉRIODE',
    PORTFOLIOACTUALCOST: 'COÛT RÉEL',
    SAVINGS: 'ÉCONOMIES',
    FuelType: 'Type de carburant',
    Emissions: 'ÉMISSIONS',
    CARBONAVOIDANCE: 'Évitement carbone',
    carbonEmissionsAvoidance: 'Évitement des émissions de carbone',
    TOTALAVOIDANCETOOLTIP:
      "Évitement carbone calculé pour la durée sélectionnée à partir de données réelles par rapport aux données de l'année précédente.",
    Meters: 'Compteurs',
    ActivePower: 'Puiss. active',
    ActivePowerContent:
      'Puissance instantanée mesurée pour un moment particulier.',
    AVGpower: 'Puissance moyenne',
    PeakPower: 'Puiss. max.',
    PeakPowerContent:
      'Demande maximale de puissance pour la plage de dates sélectionnée.',
    LoadType: 'Type de charge',
    LoadTypeContent: 'Type de charge associée au compteur.',
    FifteenMinuteElectricConsumption: 'Conso 15 min',
    FifteenMinuteElectricConsumptionPrediction: 'Prév. 15 min',
    ElectricityConsumption: "Consommation d'énergie totale",
    EnergyConsSelectedPeriod:
      "Consommation d'énergie de la période sélectionnée",
    EnergyConsToday: "Consommation d'énergie d'aujourd'hui",
    EnergyConsTodayContent: "Consommation énergétique totale pour aujourd'hui.",
    EnergyConsMonth: "Consommation d'énergie du mois",
    EnergyConsMonthContent:
      'Consommation énergétique totale pour le mois en cours.',
    TotalEnergyConsumption: "Consommation d'énergie totale",
    TotalEnergyConsumptionContent: 'Consommation totalisée des compteurs',
    EnergyConsSelectedPeriodContent:
      "Consommation d'énergie de la période sélectionnée",
    DataQuality: 'Qualité des données',
    BaselineQuality: 'Qualité de référence',
    PowerDemand: 'Demande de puissance',
    APPLYBASELINEFROMDATEINVALID:
      'Veuillez sélectionner une date qui ne remonte pas aux 15 derniers jours',
    INVALIDEXCLUSIONRANGESELECTION:
      "Veuillez sélectionner une date d'exclusion dans la plage de date de formation sélectionnée"
  },
  NILM: {
    NILMModalHeader: "S'inscrire pour NILM",
    NILMMeterDetails: 'Ajouter les détails NILM',
    SmartXMeter: 'Aperçu',
    NILMDetailsTabHeader:
      'Veuillez entrer les détails de votre compteur de surveillance de la charge non intrusive (NILM) pour les ajouter dans HSBM',
    NILMDetailsTabSubHeader: 'Détails du compteur NILM',
    NILMMeterId: 'ID/UUID de données',
    NILMDISAGGREGATEDMETERID: 'ID/UUID de données désagrégées (en option)',
    NILMMeterName: 'Nom du compteur',
    NILMAddMeter: 'Ajouter un Compteur',
    NIMAssignMainMeter: 'Affecter comme compteur principal',
    NILMNextButton: 'Suivant',
    NILMSubmitButtom: 'Soumettre',
    NILMCancelButton: 'Annuler',
    NILMcardheader: 'Surveillance de la charge non intrusive (NILM)',
    NILMcardsubheader:
      "Déterminer la répartition de la consommation d'énergie de votre site en fonction des types d'équipements",
    NILMRedirect: 'Vous serez redirigé dans 5 secondes',
    NILMAccountVerification: 'Vérification du compte en cours',
    NILMAccountVerificationSuccess: 'La vérification du compte est réussie',
    INVALIDNILMMETERID: "ID d'installation du compteur non valide",
    METERNAMEINVALID: 'le nom du compteur existe déjà pour le site',
    NILMMainmeter: '(Affecté comme compteur principal)',
    NILMsmartXmeterheader:
      'Vos compteurs NILM sont ci-dessous. Veuillez vérifier pour continuer et cliquez sur soumettre',
    NILMDUPLICATEMETERNAME: 'nom du compteur en double',
    NILMDUPLICATEMETERID: 'ID du compteur en double',
    IDDUPLICATETOGETHER: 'UUID en double et non valide',
    NAMEDUPLICATETOGETHER: 'le nom du compteur existe déjà et est dupliqué'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'Pour la période de 12 mois se terminant -',
    NoRecordsFound: 'Aucun enregistrement trouvé',
    LearnText: 'En savoir plus',
    outOfHundred: '/100',
    CurrentScore: 'Score actuel',
    EnergyTooltipHeader: 'Consommation énergétique',
    EnergyTooltipContent:
      'Le score Energy Star mesure la performance de votre propriété par rapport à des propriétés similaires, si elle respecte les normes en termes de climat et de caractéristiques opérationnelles.',
    EnergyStarTitle: 'Score Energy Star',
    loading: 'Chargement',
    ViewText: 'Afficher les détails du score',
    NA: 'N/A',
    SomethingWentWrong: 'Remarque',
    notifyServerError:
      "Il y a une erreur serveur. Veuillez contacter l'administrateur du système.",
    ReasonForNoScoreLabel:
      'Impossible de charger le Score Energy Star en raison de quelques erreurs techniques.',
    ViewReasonForNoScore: "Afficher la raison de l'absence de détails de score",
    EnergyStarNoScoreNote:
      'The Energy Star score displayed is from {prevMonth}, as the previous month score is unavailable.',
    EnergyStarNoScoreNoContentMessage:
      "Aucune raison trouvée pour l'absence d'informations sur le score !",
    EnergyStarNoScoreForLastMonthLabel:
      "Le score Energy Star n'a pas pu être chargé pour le mois précédent. Le score affiché concerne donc le mois récent."
  },
  equipmentSpaceMapping: {
    FILE_NOT_ACCEPTED:
      '« {fileName} » est un format de fichier non valide. Format de fichier .{extension} uniquement accepté',
    INVALIDFILE_EXTENSION:
      "Extension de fichier non valide, veuillez utiliser un fichier avec l'extension valide .{extension}.",
    INVALIDFILE_MIME:
      'Type de fichier mime non valide, veuillez utiliser un fichier avec un type mime valide : {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE:
      'La taille du fichier doit être inférieure à {size}',
    INVALIDFILE_MINALLOWEDSIZE:
      'La taille du fichier doit être supérieure à {size}',
    INVALIDFILE_UNKNOWNERROR:
      "Une erreur est survenue lors de l'accès aux informations du fichier. Impossible de valider",
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'Le fichier Excel chargé comporte des colonnes non valides. Veuillez utiliser un modèle approprié et télécharger à nouveau le fichier Excel.',
    INVALID_SCHEMA_LIST_REQ_HEADERS: 'En-têtes requis : {requiredSubHeaders}',
    EMPTY: '',
    NO_DATA: 'Le fichier ne contient pas de données',
    INVALID_DATA_CONTENT:
      'La première ligne de données doit contenir un élément spatial',
    SOME_ERROR_EXCEL_READ:
      'Une erreur est survenue lors de la lecture du fichier Excel. Erreur : {errorString}',
    SOME_ERROR_GENERAL:
      "Une erreur est survenue. Veuillez sélectionner et charger à nouveau un fichier valide. Détails de l'erreur -> {errorString}",
    PROPERTY_INVALID_DATA_TYPE: 'Type de données non valide. Autorisé : {type}',
    NAME_INVALID_SPECIAL_CHAR: 'Le nom a un caractère spécial non valide',
    NAME_INVALID_MAX_LEN: '{len} caractères max. autorisés',
    SPATIAL_ELE_NEW: 'Une nouvelle zone sera créée',
    NO_ASSOC_REMOVE:
      "Aucun capteur VAV/d'occupation associé. Veuillez supprimer cette entrée",
    PROPERTIES_INVALID: 'Certaines propriétés ne sont pas valides',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      "Pour l'ID d'élément spatial fourni ({id}), le nom de la feuille et celui enregistré sur le site ({dbSpEleName}) ne correspondent pas",
    ELEMENT_NAME_MISMATCH:
      "Pour l'ID d'élément spatial fourni ({id}), le nom de la feuille et celui enregistré sur le site ({dbEleName}) ne correspondent pas",
    DUPLICATE_ENTRIES: 'Plusieurs entrées ayant le même nom',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'Plusieurs équipements sont enregistrés sous le même nom sur le site. Veuillez renommer cet équipement avec un nom unique à associer',
    ELEMENT_ID_DNE: "{type} avec l'ID ({id}) fourni n'existe pas",
    SPATIAL_ELEMENT_ID_DNE: "La zone avec l'ID fourni ({id}) n'existe pas",
    ELEMENT_TYPE_NAME_DNE: "{type} avec ce nom n'existe pas",
    PROPERTY_DNE:
      "La propriété avec ce nom {name} n'existe pas. Veuillez vérifier"
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO:
      "Mappage et configuration de l'espace de l'équipement ZLO",
    UPLOAD_CARD_DESC_ZLO:
      "Charger l'équipement vers les données de mappage de l'espace pour l'intégration et la configuration ZLO",
    UPLOAD_MODAL_TITLE: "Charger les données d'intégration ZLO",
    VALIDATE_DATA: 'Charger',
    BACK_TO_UPLOAD: 'Précédent',
    UPLOAD_TAB_TOP_NOTE:
      "Veuillez télécharger le modèle et remplir les détails de l'élément spatial ainsi que les détails concernant l'équipement dans le modèle avant de poursuivre le chargement",
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'Télécharger le modèle XLSX',
    UPLOAD_TAB_SECOND_NOTE: '(Un seul chargement est possible à la fois)',
    UPLOAD_TAB_PLACEHOLDER: 'Glisser-déposer un fichier ici',
    VALIDATING_FILE_DATA: 'Validation des données du fichier',
    READING_FILE: 'Lecture du fichier',
    VALIDATING_FILE_SCHEMA: 'Validation du schéma du fichier',
    RETRIEVING_SITE_DATA: 'Récupération des données du site pour validation',
    VALIDATING_DATA_ENTRIES: 'Validation des données',
    ALL_ENTRIES_VALID: 'Toutes les entrées sont valides',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Veuillez cliquer sur soumettre pour continuer et vous inscrire dans HBSM',
    VIEW_ALL_ENTRIES: 'Voir toutes les entrées',
    FIX_VAL_ERRORS_MSG:
      "Vous trouverez ci-dessous les entrées incorrectes des données d'intégration et de configuration ZLO. Veuillez revenir à l'onglet de chargement et charger le fichier Excel à nouveau sans les entrées incorrectes pour l'enregistrer dans HBSM",
    VAL_OK_SUBMIT_MSG:
      'Veuillez cliquer sur soumettre pour continuer et vous inscrire dans HBSM',
    ERROR_BOX_TEXT:
      "{numErrors} erreurs identifiées. Veuillez les rectifier et charger à nouveau le fichier pour le soumettre et l'enregistrer dans HBSM",
    VALIDATION_ERROR_TITLE: 'Erreur de validation',
    TOTAL: 'Total',
    CURRENTLY_SHOWING: 'Affichage de {num} sur {total} total',
    SHOW_ALL_ENTRIES: 'Afficher toutes les entrées',
    SL_NO: 'Num. série',
    SPATIAL_ELE_NAME: "Nom de l'élément spatial",
    ELE_TYPE: "Type d'élément",
    ELE_NAME: 'Nom',
    ZLO_STATE: 'État ZLO',
    ZO_SETBACK: "Réduction d'optimisation de zone (F)",
    VAV: "Volume d'air variable",
    OCCUPANCY_SENSOR: "Capteur d'occupation",
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: "Capteur d'occupation",
    SEARCH_PLACEHOLDER: 'Rechercher',
    SEARCH_MIN_LEN: '{len} caractères min.',
    NO_DATA: 'Aucune donnée ne correspond à votre recherche',
    VALIDATING_TITLE: 'Validation du fichier chargé',
    SOME_ERROR_FETCHING_DATA:
      "Une erreur est survenue lors de l'extraction des données du site. Erreur : {errorString}",
    SUBMITTING_TITLE:
      "Veuillez patienter pendant que nous associons l'équipement à l'espace",
    SUBMITTING_SUBTITLE: 'Vous serez redirigé dans quelques secondes',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Création de nouveaux espaces',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS:
      'Mappage des équipements avec les espaces',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      "Erreur dans le mappage de l'élément avec l'élément spatial. Réessayez ultérieurement",
    UPDATING_PROPERTIES: 'Mise à jour des propriétés',
    SUBMISSION_SUCCESS_TITLE: "Mappage de l'équipement avec l'espace réussi",
    SUBMISSION_ERROR_TITLE: 'Erreur lors de la soumission des données',
    SUBMISSION_ERROR_MESSAGE:
      'Une erreur est survenue lors de la soumission des données. Réessayez ultérieurement',
    BULK_CREATION_ERROR_MESSAGE:
      "Une erreur est survenue lors de la création d'éléments spatiaux. Réessayez ultérieurement.",
    UPDATE_PROPERTY_ERROR_MESSAGE:
      'Une erreur est survenue lors de la mise à jour des propriétés. Réessayez ultérieurement.',
    SUBMISSION_SUCCESS_SUBTITLE:
      "Les capteurs VAV et d'occupation cartographés aux espaces reflèteraient sous l'onglet Équipements dans la page d'accueil du site",
    GOTO_SITE_HOME_PAGE: "Aller à la page d'accueil du site",
    'Items per Page': 'Lignes par page'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      "Les informations ci-dessous sont toujours affichées selon le cycle d'information de facturation"
  },
  UtilityBuilder: {
    NEWBILL: 'Nouvelle facture',
    ENTERDATAMANUALLY: 'Saisir les données manuellement',
    BILLNAME: 'Nom de la facture',
    BILLINGDATE: 'Date de facturation',
    TOTAL_BILL_AMOUNT: 'Montant total de la facture',
    BILLING_PERIOD_CONSUMPTION: 'Consommation de la période de facturation',
    BILLING_DEMAND: 'Demande de facturation',
    ENTER_PLACEHOLDER: 'Saisir',
    SELECT_PLACEHOLDER: 'Sélectionner',
    CATEGORIES: 'Catégories',
    ACCOUNTNUMBER: 'Numéro de compte',
    UTILITYTYPE: "Type d'utilitaire",
    BILLINGCYCLE: 'Cycle de facturation',
    UPLOADELECTRICITYBILL: "Charger la facture d'électricité",
    UPLOADGASBILL: 'Télécharger la facture de gaz',
    ADDELECTRICITYBILL: "Ajouter une facture d'électricité",
    ADDGASBILL: 'Ajouter une facture {utilityType}',
    UPLOADUTILITYBILL: 'Charger la facture de services',
    PDFUPLOADPROMPT:
      'Veuillez télécharger un fichier PDF de la facture de services.',
    UploadElectricitybill: "Charger la facture d'électricité*",
    Utilitybill: 'Facture de services',
    UPLOADBILL: 'Charger la facture {utilityType}',
    UPLOADELECTRICITYBILLNONMANDATORY: "Charger la facture d'électricité",
    FILENAMECONTAINSPACES: 'Le nom de fichier contient des espaces.',
    FILENAMECONTAINSPECIALCHARACTER:
      'Le nom de fichier contient des caractères spéciaux.',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Catégories de factures',
    REFERSAMPLEBILL: "Reportez-vous à l'exemple de facture.",
    INPUTCATEGORIES:
      "Veuillez saisir les différentes catégories et les coûts correspondants à partir de votre facture {utilityType}. Si vous avez besoin d'aide pour les localiser sur la facture, "
  },
  baseline: {
    baselineconfiguration: 'Configuration de référence',
    baselineConfigDesc:
      "Les références ajustées établissent la consommation prévue d'énergie pour un site, en fonction d'une combinaison de consommation historique, de tendances récentes et de facteurs d'influence connus comme les variables météorologiques.",
    baseline: 'Niveau de référence',
    total: 'Total',
    searchPlaceholder: 'Rechercher',
    create: 'Créer une référence',
    view: 'Afficher la référence',
    baselineQuality: 'Qualité de référence',
    baselinePeriod: 'Période de référence',
    reportingPeriod: 'Période du rapport',
    estBaselinePeriod: 'Établir une période de référence',
    baselinePeriodDescription:
      'Sélectionnez la période de référence et la période de rapport pour lesquelles vous devez créer une référence',
    independentVariables: 'Variables indépendantes',
    autoSelectBest: 'Sélection automatique des meilleures variables',
    utilityDataType: 'Type de données de services',
    calendarMonth: 'Mois calendaire',
    billingPeriod: 'Période de facturation',
    tStat: 'T-Stat (Stat T)'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'AJOUTER UN COMPTE',
    ADD_METERS: 'AJOUTER DES COMPTEURS'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Montant total de la facture',
  Consumption: 'Consommation',
  Demand: 'Demande',
  'Service Charges': 'Frais de service',
  'Transmission & Distribution': 'Transmission et distribution',
  Others: 'Autres',
  'Demand Charges': 'Frais de demande',
  'Total Cost': 'Coût total',
  Total: 'Total'
};
